import type { ReactNode } from "react";
import { lazy, Suspense } from "react";

const clientKey = import.meta.env.VITE_STATSIG_CLIENT_KEY;
const analyticsTool = import.meta.env.VITE_ANALYTICS_TOOL;
const isStatsigAvailable = analyticsTool === "statsig" && clientKey;

const LazyAppStatsigProvider = isStatsigAvailable
  ? lazy(() => import("./StatsigProvider").then((m) => ({ default: m.AppStatsigProvider })))
  : null;

export function StatsigPreloadProvider({ children }: { children: ReactNode }) {
  if (!isStatsigAvailable || !LazyAppStatsigProvider) {
    return children;
  }

  return (
    <Suspense fallback={null}>
      <LazyAppStatsigProvider>{children}</LazyAppStatsigProvider>
    </Suspense>
  );
}
